import React from "react";

import "./styles.css";

type Props = {
  children: React.ReactNode
}

export const ReportSection = ({ children }: Props) => (
  <div className="report__values-section report-values-section">
    {children}
  </div>
)
